BaseModel = require 'BaseModel'
gameModel = require 'gameModel'

###############################################

class ImageModel extends BaseModel

  _instance: null
  allNamespaces: []
  prizeImages: []
  lang: 'de'
  res: ''

  # -------------------------------------------

  setup: ->

    @res = @determineResolutionPostfix()

    # shared images

    @fingerImg = require "../../img/finger/finger#{@res}.png"
    @brushImage = require "../../img/brush/brush#{@res}.png"

    # theme images

    @flakeImage = require "../../themes/#{__themeCode}/img/flake#{@res}.png"
    @scratchedImage = require "../../themes/#{__themeCode}/img/scratch-bg#{@res}.png"
    @unscratchedImage = require "../../themes/#{__themeCode}/img/scratch-cover#{@res}.png"
    @logoTitleImage = require "../../themes/#{__themeCode}/img/logo-title#{@res}.png"
    @backgroundImage = require "../../themes/#{__themeCode}/img/background#{@res}.jpg"

    # shared sprites

    @confettiJSON1 = require '../../sprite/confetti-0.json'
    @confettiJSON2 = require '../../sprite/confetti-1.json'
    @confettiURL1 = require '../../sprite/confetti-0.png'
    @confettiURL2 = require '../../sprite/confetti-1.png'
    @allNamespaces.push @confettiJSON1
    @allNamespaces.push @confettiJSON2

    @uiJSON = require "../../sprite/buttons#{@res}.json"
    @uiURL = require "../../sprite/buttons#{@res}.png"
    @allNamespaces.push @uiJSON

    # theme sprites

    @buttonImage = require "../../themes/#{__themeCode}/img/button#{@res}.png"
    @buttonHoverImage = require "../../themes/#{__themeCode}/img/button-hover#{@res}.png"
    @buttonSecondaryImage = require "../../img/btn/button-secondary#{@res}.png"
    @buttonSecondaryHoverImage = require "../../img/btn/button-secondary-hover#{@res}.png"

    preload = [
      @fingerImg
      @logoTitleImage
      @flakeImage
      @brushImage
      @scratchedImage
      @unscratchedImage
      @backgroundImage
      @buttonImage
      @buttonHoverImage
      @buttonSecondaryImage
      @buttonSecondaryHoverImage

      @confettiJSON1
      @confettiJSON2
      @uiJSON
    ]

    # conditional theme assets to preload

    if gameModel.showLogoInGame
      @logoGameImage = require "../../themes/#{__themeCode}/img/logo-game#{@res}.png"
      preload.push @logoGameImage

    if not gameModel.hasPrizeAnimations
      @starImage = require "../../themes/#{__themeCode}/img/star#{@res}.png"
      preload.push @starImage

    if gameModel.showCharacter
      @characterImage = require "../../themes/#{__themeCode}/img/character#{@res}.png"
      preload.push @characterImage

    if gameModel.winSign is 'movie'
      @winSignJSON = require "../../sprite/win-sign#{@res}.json"
      require "../../sprite/win-sign#{@res}.png"
      @allNamespaces.push @winSignJSON
      preload.push @winSignJSON

    if gameModel.winSign is 'image'
      @winSignImage = require "../../themes/#{__themeCode}/img/win-sign#{@res}.png"
      preload.push @winSignImage

    preload

  # -------------------------------------------

  _twoDigits: (n) ->
    ("0" + n).slice(-2)

  # -------------------------------------------

  determineResolutionPostfix: ->
    return '' if __dpi is 1
    postfix = "@#{__dpi}x"
    postfix

  # -------------------------------------------

  getUrlForPrize: (filename) ->
    return require "../../themes/#{__themeCode}/img/prize-#{filename}#{@res}.png"

  # -------------------------------------------

  getUrlForMultiplier: (filename) ->
    return require "../../themes/#{__themeCode}/img/multiplier-x#{filename}#{@res}.png"

  # -------------------------------------------

  getWinAnimationForPrizeid: (filename) ->
    return require "../../themes/#{__themeCode}/sprite/prize-#{filename}#{@res}.json"
    require "../../themes/#{__themeCode}/sprite/prize-#{filename}#{@res}.png"

  # -------------------------------------------

  getMultiAnimationForPrizeid: (filename) ->
    return require "../../themes/#{__themeCode}/sprite/multi-#{filename}#{@res}.json"
    require "../../themes/#{__themeCode}/sprite/multi-#{filename}#{@res}.png"

  # -------------------------------------------

  retinize: (url) ->
    return url if __dpi < 2
    nurl = url.replace(/\.(?=[^.]*$)/, "@2x.")
    nurl

  # -------------------------------------------

  # make Singleton
  @getInstance: ->
    @_instance = new @ if not @_instance?
    @_instance

  # -------------------------------------------

module.exports = ImageModel.getInstance()



// WEBPACK FOOTER //
// ./coffee/model/image-model.coffee